// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Pagination{display:inline-flex;align-items:center;flex-grow:1;flex-wrap:wrap;justify-content:center;padding-left:0;border:1px solid #aaa;list-style-type:none}.Pagination_Item:nth-of-type(n+2){border-left:1px solid #aaa}.Pagination_Link{display:block;padding:1em}.-active .Pagination_Link{background-color:#aaa}\n", ""]);
// Exports
module.exports = exports;
